import { render, staticRenderFns } from "./ProductTabs.vue?vue&type=template&id=5da11b3f&"
import script from "./ProductTabs.vue?vue&type=script&lang=ts&"
export * from "./ProductTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports